'use strict'
require('core-js/modules/es.date.to-string')
require('core-js/modules/es.object.to-string')
require('core-js/modules/es.regexp.to-string')
exports.__esModule = true
exports.isDate = isDate
exports.checkTimestamp = checkTimestamp

var _is = require('../is')

/**
 * isDate
 *
 *
 * @param {*} maybeDate
 * @returns {boolean}
 * @memberof Time
 *
 */
function isDate(maybeDate) {
  return maybeDate instanceof Date
}

/**
 * Проверяет timestamp в секундах или милисекундах
 *
 *
 * @param {?number} ts
 * @example
 * checkTimestamp( '123' )
 * // { isValid: false }
 *
 * checkTimestamp( 1528547903882 )
 * // { isValid: true, isInSec: false, isInMs: true, ts: 1528547903882 }
 *
 * checkTimestamp( 1528547903 )
 * // { isValid: true, isInSec: true, isInMs: false, ts: 1528547903 }
 * @returns {CheckTimestampReturnType}
 * @memberof Time
 */
function checkTimestamp(ts) {
  if (!(0, _is.isNum)(ts)) return { isValid: false }
  var asStr = ts.toString()
  var isLength13 = asStr.length === 13
  return {
    isValid: true,
    isInSec: !isLength13,
    isInMs: isLength13,
    ts: ts
  }
}



//////////////////
// WEBPACK FOOTER
// ./~/hlp/dist/Time/misc.js
// module id = 164
// module chunks = 0